import { makeStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '10px 25px 14px',
    color: 'white',
    borderRadius: '10px',
    backgroundColor: theme.palette.error.main,
    boxShadow: 'rgba(0, 0, 0, 0.24) 0px 3px 8px',
  },
  marginLeft: {
    marginLeft: '10px',
  },
}))

const Snackbar = ({ content, icon }) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {icon}
      <Typography className={icon ? classes.marginLeft : ''} variant="body2">
        {content}
      </Typography>
    </div>
  )
}

export default Snackbar
